import { connect } from 'react-redux'

import { setSlug } from 'components/Modal/DocumentPopupWindow/reducer'
import { getData } from './reducer'

const mapStateToProps = (state) => {
    return {
        data: state?.components?.basket?.data ?? null,
        basketLoading: state?.components?.basket?.loading ?? false,
    }
}

const hocConnect = (InnerComponent) => connect(mapStateToProps, { getData, setSlug })(InnerComponent)

export default hocConnect
